import * as types from './types';

export function transformAlertRulesToRequestData(alert: types.Alerts) {
  return {
    id: alert.id,
    type: alert.type,
    title: alert.title,
    inputVariables: alert.inputVariables,
    inputValues: alert.inputValues,
    preferences: alert.preferences,
  };
}

export function transformResponseToAlertRules(response: any) {
  return response.data.resources.map((data) => (
    types.mkAlerts({
      id: data.id,
      type: data.type,
      title: data.title,
      inputVariables: data.inputVariables,
      inputValues: data.inputValues,
      preferences: data.preferences,
    })
  ));
}
